module.exports = __webpack_public_path__ + "static/media/otto.4a555a83.png";